<template>
  <div class="seo clearfix">
    <ui-topbar :logs="true"></ui-topbar>
    <router-view></router-view>
    <ui-footer></ui-footer>
  </div>
</template>

<script>
import Topbar from '@/components/layout/Topbar.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
  name: 'Seo',
  components:{
    'ui-footer': Footer,
    'ui-topbar': Topbar
  },
  metaInfo: {
    title: '雪帝数字音频', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '雪帝数字音频'
    },
      {
        name: 'description',
        content: '雪帝数字音频'
      }]
  }
}
</script>

<style scoped lang='less'>
.seo{
}
@media (max-width: 1200px) {
}
</style>



// WEBPACK FOOTER //
// src/components/article/Article.vue